import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { AgGridModule } from 'ag-grid-angular';
import { EntityListRoutingModule } from './entity-list-routing.module';
import { WidgetsModule } from '../../widgets/widgets.module';
import { EntityListComponent } from './entity-list.component';
import { ResearchLayoutModule } from '../../components/research-layout/research-layout.module';
import { EntityScreenModule } from '../../components/entity-screen/entity-screen.module';
import { EntityPanelComponent } from '../../components/entity-panel/entity-panel.component';
import { EntityPanelModule } from '../../components/entity-panel/entity-panel.module';

@NgModule({
    imports: [
        AgGridModule,
        CommonModule,
        WidgetsModule,
        ResearchLayoutModule,
        EntityScreenModule,
        EntityPanelModule
    ],
    declarations: [
        EntityListComponent
    ],
    exports: [
        EntityListComponent
    ]

})
export class EntityListModule { }
